import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import CategoryPage from "../pages/category/page";
import ComicPage from "../pages/comic/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "/category/:slug",
        element: <CategoryPage />,
      },
      {
        path: "/comic/:id",
        element: <ComicPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;